import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { fetchPartnerStoriesList } from "../../store/actions/globalActions";
import { host } from "../../utils/globals";
import { PARTNERS_STORIES_LIST_API_URL } from "../../store/constants/urls";
import Loading from "../common/Loading";
import "../homePage/partnerStories/partnerStories.css";
import { scrollTop } from "../../utils/helpers";
import $ from "jquery";

class PartnerStoryList extends Component {
  state = {
    page: 1
  };

  componentDidMount() {
    this.props.dispatch(fetchPartnerStoriesList());
    scrollTop();
    this.paginateData();
  }

  paginateData() {
    let self = this;
    $(document).on("click", " ul#partner-stories-pagination > li", e => {
      e.preventDefault();
      let target = $(e.target).closest("li");
      let page = target.data("page");
      let url = `${PARTNERS_STORIES_LIST_API_URL}?page=${page}`;
      page && self.props.dispatch(fetchPartnerStoriesList(url));
      self.setState({ page });
      scrollTop();
    });
  }

  render() {
    let { isFetching, partnerStories } = this.props.partnerStories;
    let pagination = "";
    if (partnerStories && partnerStories.totalPage > 1) {
      for (let i = 1; i <= partnerStories.totalPage; i++) {
        pagination += `<li className="${
          this.state.page === i ? "active" : ""
        }" data-page=${i}><a href="#">${i}</a></li>`;
      }
    }
    let { isEnglish } = this.props;
    let view = isFetching ? (
      <Loading />
    ) : (
      <Fragment>
        {partnerStories &&
          partnerStories.data &&
          partnerStories.data.map(d => (
            <div className="col-xs-12 col-sm-4 partner-story-block" key={d.id}>
              <NavLink
                to={`/partner-story/${d.id}`}
                className="story-item thumbnail"
              >
                <figure>
                  <img
                    src={`${host}${d.image}`}
                    className="hover-zoom"
                    alt=""
                  />
                </figure>
                <div className="caption">
                  <h1>{isEnglish ? d.title : d.title_nepali}</h1>
                  <p>{isEnglish ? d.short_desc : d.short_nepali_desc}</p>
                  <NavLink
                    to={`/partner-story/${d.id}`}
                    className="btn btn-primary"
                  >
                    read more
                  </NavLink>
                </div>
              </NavLink>
            </div>
          ))}
      </Fragment>
    );
    return (
      <section id="partnerStories">
        <div className="hrrp-breadcrumb">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <h1>Partner Stories</h1>
                <ol className="breadcrumb">
                  <li>
                    <NavLink to="/">home</NavLink>
                  </li>
                  <li className="active">Partner Stories</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-xs-12">{view}</div>
            <div className="clearfix"></div>
            <ul
              id="partner-stories-pagination"
              className="pagination"
              dangerouslySetInnerHTML={{ __html: pagination }}
            />
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  return {
    partnerStories: state.partnerStories,
    isEnglish: state.changeLanguage.isEnglish
  };
};

export default connect(mapStateToProps)(PartnerStoryList);
